module.exports = require("/Users/sugandar/Sites/CrewCore/src/Redux/store.ts")